export default __webpack_public_path__ + "static/media/site_imanstore.58027ebd.webp";